<template>
  <section class="lk-step">
    <div class="lk-group">
      <span
        class="field-label"
        id="lk-lbl-gender"
      >Ich bin…</span>
      <div
        class="pill-row"
        role="radiogroup"
        aria-labelledby="lk-lbl-gender"
      >
        <button
          type="button"
          class="pill"
          role="radio"
          :class="{ selected: gender === 'male' }"
          :aria-checked="gender === 'male'"
          @click="$emit('update:gender', 'male')"
        >
          Mann
        </button>
        <button
          type="button"
          class="pill"
          role="radio"
          :class="{ selected: gender === 'female' }"
          :aria-checked="gender === 'female'"
          @click="$emit('update:gender', 'female')"
        >
          Frau
        </button>
      </div>
    </div>
    <div class="lk-group">
      <span
        class="field-label"
        id="lk-lbl-pref"
      >Ich suche…</span>
      <div
        class="pill-row"
        role="group"
        aria-labelledby="lk-lbl-pref"
      >
        <button
          type="button"
          class="pill"
          :class="{ selected: prefSelected('male'), muted: prefMuted('male') }"
          @click="setPreferred('male')"
        >
          Männer
        </button>
        <button
          type="button"
          class="pill"
          :class="{ selected: prefSelected('female'), muted: prefMuted('female') }"
          @click="setPreferred('female')"
        >
          Frauen
        </button>
        <button
          type="button"
          class="pill"
          :class="{ selected: prefSelected('all'), muted: prefMuted('all') }"
          @click="setPreferred('all')"
        >
          Alle
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LeadFunnelStepGender',
  props: {
    gender: { type: String, default: '' },
    preferredGender: { type: Array, default: () => [] },
  },
  computed: {
    prefIsAll() {
      return this.preferredGender.length === 2;
    },
  },
  methods: {
    prefSelected(v) {
      return this.prefIsAll ? v === 'all' : this.preferredGender.indexOf(v) !== -1;
    },
    prefMuted(v) {
      return this.prefIsAll && v !== 'all';
    },
    setPreferred(value) {
      this.$emit('update:preferredGender', value === 'all' ? ['female', 'male'] : [value]);
    },
  },
};
</script>
